import { http } from '@/api/client/httpClient';
import type {
  PortfolioEquityDetailedRowDto,
  PortfolioEquityFilterInput,
  PortfolioEquitySummaryDto,
} from '@/api/types/portfolioEquity';

const BASE = '/api/app/portfolio-equity';

export const portfolioEquityApi = {
  getSummary: (input: PortfolioEquityFilterInput) =>
    http.get<PortfolioEquitySummaryDto>(`${BASE}/summary`, { params: input }).then((r) => r.data),
  getDetailed: (input: PortfolioEquityFilterInput & { skipCount?: number; maxResultCount?: number }) =>
    http
      .get<{ items: PortfolioEquityDetailedRowDto[]; totalCount: number }>(`${BASE}/detailed-report-for-data-table`, { params: input })
      .then((r) => r.data),
  extractExcelUrl: `${BASE}/extract-excel`,
};
